import { render, staticRenderFns } from "./wallet-usage.vue?vue&type=template&id=2f436f40&scoped=true"
import script from "./wallet-usage.vue?vue&type=script&lang=js"
export * from "./wallet-usage.vue?vue&type=script&lang=js"
import style0 from "./wallet-usage.vue?vue&type=style&index=0&id=2f436f40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f436f40",
  null
  
)

export default component.exports